import { AfterViewInit, Component, Input } from '@angular/core';
import { PlatformService } from 'src/app/_services/platform.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BannerFundsCtaCorrienteComponent } from 'src/app/home/banner-portada/banner-funds-cta-corriente/banner-funds-cta-corriente.component';
import { BannerFundsDepositosComponent } from 'src/app/home/banner-portada/banner-funds-depositos/banner-funds-depositos.component';
import { BannerFundsTematicasComponent } from 'src/app/home/banner-portada/banner-funds-tematicas/banner-funds-tematicas.component';
import { BannerSegoBlogComponent } from 'src/app/home/banner-portada/banner-sego-blog/banner-sego-blog.component';
import { BannerSegofinanceComponent } from 'src/app/home/banner-portada/banner-segofinance/banner-segofinance.component';
import { BannerFactoringNuevoComponent } from 'src/app/home/banner-portada/banner-factoring-nuevo/banner-factoring-nuevo.component';
import { BannerAutoinvestComponent } from 'src/app/home/banner-portada/banner-autoinvest/banner-autoinvest.component';
import { BannerCalculadoraComponent } from 'src/app/home/banner-portada/banner-calculadora/banner-calculadora.component';
import { BannerFundsCriptoComponent } from 'src/app/home/banner-portada/banner-funds-cripto/banner-funds-cripto.component';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import { BannerVentureMotoretoComponent } from 'src/app/home/banner-portada/banner-venture-motoreto/banner-venture-motoreto.component';
import { BannerLillianComponent } from 'src/app/home/banner-portada/banner-lillian/banner-lillian.component';
import { BannerVentureDrimerComponent } from 'src/app/home/banner-portada/banner-venture-drimer/banner-venture-drimer.component';


@Component({
  selector: 'app-banner-portada',
  templateUrl: './banner-portada.component.html',
  styleUrls: ['./banner-portada.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    BannerFundsCtaCorrienteComponent,
    BannerFundsDepositosComponent,
    BannerFundsTematicasComponent,
    BannerSegofinanceComponent,
    BannerSegoBlogComponent,
    BannerFactoringNuevoComponent,
    BannerAutoinvestComponent,
    BannerCalculadoraComponent,
    BannerFundsCriptoComponent,
    BannerFundsCriptoComponent,
    BannerVentureMotoretoComponent,
    BannerLillianComponent,
    BannerVentureDrimerComponent
  ]
})
export class BannerPortadaComponent implements AfterViewInit
{
  @Input() plataformaId: string;
  domainUrlVenture: string;
  domainUrlRealEstate: string;
  domainUrlFactoring: string;
  domainUrlFunds: string;
  domainUrlCreative: string;
  swiperPortada: Swiper;
  isBannerNavidadActive: boolean = false;

  constructor(private _platformService: PlatformService)
  {
    this.domainUrlVenture = this._platformService.getSubdominioUrl('venture');
    this.domainUrlRealEstate = this._platformService.getSubdominioUrl('realestate');
    this.domainUrlFactoring = this._platformService.getSubdominioUrl('factoring');
    this.domainUrlFunds = this._platformService.getSubdominioUrl('funds');
    this.domainUrlCreative = this._platformService.getSubdominioUrl('creative');
  }

  ngAfterViewInit(): void
  {
    this.buildSwiper();
  }

  private buildSwiper(): void
  {
    this.swiperPortada = new Swiper('.swiperPortada', {
      modules: [Autoplay, Pagination],
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination-portada',
        clickable: true,
      },
    });
  }
}